import Image from "next/image"
import { Banner } from "@/components/ui/banner"

function RainbowBanner() {
    return (
        <div className="relative w-full mx-auto">
            <Banner
                message=""
                height="2rem"
                variant="rainbow"
                className="mb-0"
            />

            {/* <div className="relative w-full aspect-[16/9] rounded-lg overflow-hidden">
                <Image
                    src="https://www.launchuicomponents.com/app-light.png"
                    alt="Application screenshot"
                    fill
                    className="object-cover"
                    priority
                />
            </div> */}
        </div>
    )
}


function BannerNav() {
    return (
        <div className="relative w-full">
            <Banner
                message="🎉 New features coming soon!"
                height="2rem"
                className="mb-4"
            />

            <div className="relative w-full aspect-[16/9] rounded-lg overflow-hidden">
                <Image
                    src="https://www.launchuicomponents.com/app-light.png"
                    alt="Application screenshot"
                    fill
                    className="object-cover"
                    priority
                />
            </div>
        </div>
    )
}

export { RainbowBanner, BannerNav }